import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-cream">
        <div className="text-brand-green font-serif text-2xl">Loading…</div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
